import { useDispatch, useSelector } from "react-redux";
import { printCtrlGoodsThunk } from "../thunks/printCtrlGoodsThunk";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { CtrlGoodsData } from "../types";
import { setDownloadFetchState } from "../ctrlGoodsDataSlice";

export const useCtrlGoodsPrinter = (ctrlGoods?: CtrlGoodsData) => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.clearing.controls.downloadReportFetchState
	);
	const dispatch = useDispatch();

	const download = React.useCallback(() => {
			dispatch(printCtrlGoodsThunk(ctrlGoods));
	}, [dispatch,ctrlGoods]);

	const dispatchSetFetch = React.useCallback(() => {                   //  Ovo da prvo izađe customDialog box
		dispatch(setDownloadFetchState({ type: "started" }))
	},	[dispatch] );
	
	return [download, fetchState, dispatchSetFetch] as [typeof download, typeof fetchState, typeof dispatchSetFetch];
};
